webpackJsonp([23718644409033],{

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _sectionTitle = __webpack_require__(14);
	
	var _sectionTitle2 = _interopRequireDefault(_sectionTitle);
	
	__webpack_require__(165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityBlock = function (_React$Component) {
	    _inherits(ActivityBlock, _React$Component);
	
	    function ActivityBlock(props) {
	        _classCallCheck(this, ActivityBlock);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    ActivityBlock.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'activity-block' },
	            _react2.default.createElement(
	                'div',
	                { className: 'block-row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block-row__grid block-row__text' },
	                    _react2.default.createElement(_sectionTitle2.default, { title: 'Nature Walks', color: 'black' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'rc-copy small' },
	                        'Nature walks are exciting for kids. There is so much to see and explore along the walks. So much to touch, smell and feel. Along the way gathering and picking up thing, collecting leaves, pine cones, twigs and learning about them. Tracking animal footprints, looking at different insects.'
	                    )
	                ),
	                _react2.default.createElement('div', { className: 'block-row__grid block-row__img nature' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'block-row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block-row__grid block-row__text block-row__grid--mobile' },
	                    _react2.default.createElement(_sectionTitle2.default, { title: 'Activities around the home', color: 'black' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'rc-copy small' },
	                        'Keeping children busy with painting and colouring, also art and craft activities for learning. Learning about the garden, plants, trees, etc. Potting new plants and seeds, watching them grow. Playing with sand, making sand castles. Making birthday and special days\' cards.'
	                    )
	                ),
	                _react2.default.createElement('div', { className: 'block-row__grid block-row__img childart' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block-row__grid block-row__text block-row__grid--desktop' },
	                    _react2.default.createElement(_sectionTitle2.default, { title: 'Activities around the home', color: 'black' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'rc-copy small' },
	                        'Keeping children busy with painting and colouring, also art and craft activities for learning. Learning about the garden, plants, trees, etc. Potting new plants and seeds, watching them grow. Playing with sand, making sand castles. Making birthday and special days\' cards.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'block-row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block-row__grid block-row__text' },
	                    _react2.default.createElement(_sectionTitle2.default, { title: 'Visits to local child groups', color: 'black' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'rc-copy small' },
	                        'Learning to interact with other children in play and activities. Learning to share equipment and working together as groups. Keeping the youngsters happy and fit by playing games.'
	                    )
	                ),
	                _react2.default.createElement('div', { className: 'block-row__grid block-row__img childgroup' })
	            )
	        );
	    };
	
	    return ActivityBlock;
	}(_react2.default.Component);
	
	exports.default = ActivityBlock;
	module.exports = exports['default'];

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _sectionTitle = __webpack_require__(14);
	
	var _sectionTitle2 = _interopRequireDefault(_sectionTitle);
	
	__webpack_require__(165);
	
	var _reactFontawesome = __webpack_require__(10);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _fontawesomeFreeSolid = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityMap = function (_React$Component) {
	    _inherits(ActivityMap, _React$Component);
	
	    function ActivityMap(props) {
	        _classCallCheck(this, ActivityMap);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    ActivityMap.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'activity-map' },
	            _react2.default.createElement(
	                'div',
	                { className: 'activity-map--block' },
	                _react2.default.createElement(_sectionTitle2.default, { title: 'and the learning continues...', color: 'yellow' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'activity-map--desc rc-copy small' },
	                    _react2.default.createElement(_reactFontawesome2.default, { icon: _fontawesomeFreeSolid.faArrowAltCircleRight }),
	                    'Visits to local libraries'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'activity-map--desc rc-copy small' },
	                    _react2.default.createElement(_reactFontawesome2.default, { icon: _fontawesomeFreeSolid.faArrowAltCircleRight }),
	                    'Reading favourite books'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'activity-map--desc rc-copy small' },
	                    _react2.default.createElement(_reactFontawesome2.default, { icon: _fontawesomeFreeSolid.faArrowAltCircleRight }),
	                    'Learning about numbers'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'activity-map--desc rc-copy small' },
	                    _react2.default.createElement(_reactFontawesome2.default, { icon: _fontawesomeFreeSolid.faArrowAltCircleRight }),
	                    'Learning to write the alphabet'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'activity-map--desc rc-copy small' },
	                    _react2.default.createElement(_reactFontawesome2.default, { icon: _fontawesomeFreeSolid.faArrowAltCircleRight }),
	                    'Learning about different words & sounds'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'activity-map--desc rc-copy small' },
	                    _react2.default.createElement(_reactFontawesome2.default, { icon: _fontawesomeFreeSolid.faArrowAltCircleRight }),
	                    'Trips to local shops'
	                )
	            )
	        );
	    };
	
	    return ActivityMap;
	}(_react2.default.Component);
	
	exports.default = ActivityMap;
	module.exports = exports['default'];

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _sectionTitle = __webpack_require__(14);
	
	var _sectionTitle2 = _interopRequireDefault(_sectionTitle);
	
	var _activityBlock = __webpack_require__(208);
	
	var _activityBlock2 = _interopRequireDefault(_activityBlock);
	
	var _activityMap = __webpack_require__(209);
	
	var _activityMap2 = _interopRequireDefault(_activityMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Activities = function Activities() {
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(_banner2.default, { type: 'activities', title: 'Activities' }),
			_react2.default.createElement(
				'section',
				{ className: 'page-grid' },
				_react2.default.createElement(
					'section',
					{ className: 'page-grid-section' },
					_react2.default.createElement(
						'div',
						{ className: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'text-center intro-div' },
							_react2.default.createElement(_sectionTitle2.default, { title: 'Fun & adventure starts here' }),
							_react2.default.createElement('br', null)
						),
						_react2.default.createElement('br', null),
						_react2.default.createElement(_activityBlock2.default, null),
						_react2.default.createElement('br', null),
						_react2.default.createElement(_activityMap2.default, null)
					)
				)
			)
		);
	};
	
	exports.default = Activities;
	module.exports = exports['default'];

/***/ }),

/***/ 165:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-activities-js-3d038478dfff4dc07c6a.js